var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.429 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 7 C 5 5.895 5.895 5 7 5 C 8.105 5 9 5.895 9 7 C 9 8.105 8.105 9 7 9 C 5.895 9 5 8.105 5 7 Z",
    fill: "transparent",
    stroke: "rgb(76, 106, 112)",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7 2 L 7 0 M 7 14 L 7 12 M 0 7 L 2 7 M 12 7 L 14 7 M 3.464 3.464 L 2.049 2.05 M 11.949 11.95 L 10.535 10.536 M 2.05 11.95 L 3.464 10.536 M 10.534 3.464 L 11.948 2.05",
    fill: "transparent",
    stroke: "rgb(76, 106, 112)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.a460c1fa088ff844a8752ca3732bf276.svg";
export { ForwardRef as ReactComponent };